<template>
<div class="evan-icon" :class="svg?'evan-icon__svg':''" ref="componentRef" :style="componentStyle" @click="clickIcon">
  <span v-if="prefix !== ''" class="text" :style="{fontSize:fontSize,lineHeight:fontSize}" v-html="prefix"></span>
  <svg  @mouseover="showPreviewVisible = true" @mouseleave="showPreviewVisible = false" class="icon" v-if="svg" :style="{width: width,height: height}" aria-hidden="true">
    <use v-bind:xlink:href="'#'+icon"></use>
  </svg>
  <i class="iconfont translate-icon" v-if="!svg" :class="icon" :style="{fontSize: fontSize,lineHeight:1}"></i>
  <span v-if="append !== ''" class="text" :style="{fontSize:appendFontSize,lineHeight:appendFontSize}" v-html="append"></span>
  <div v-show="showPreview&&showPreviewVisible" class="tracking-in-expand" style="position: absolute;">
    <svg class="icon" style="position: absolute;z-index: 1!important;pointer-events: none;" :style="{width: previewWidth,height: previewHeight,bottom:'-'+previewHeight,left:'50%'}" aria-hidden="true">
      <use v-bind:xlink:href="'#'+icon" style="pointer-events: none;z-index: 1!important;"></use>
    </svg>
  </div>
</div>

</template>

<script>
import {REGEXPS} from "@/constant/Constants";

export default {
  name: "EvanIcon",
  props:{
    svg: {
      type: Boolean,
      default: false,
    },
    z: {
      type: Boolean,
      default: false,
    },
    prefix:{
      type: String,
      required: false,
      default: '',
    },
    append:{
      type: String,
      required: false,
      default: '',
    },
    icon:{
      type: String,
      required: false,
      default: 'icon-logo1',
    },
    size: {
      type: String | Number,
      required: false,
      default: '1em',
    },
    appendFS:{
      type: String | Number,
      required: false,
      default: '1em',

    },
    showPreview: {
      type: Boolean,
      default: false,
    },
    previewWidth:{
      type: String,
      required: false,
      default: '200px',
    },
    previewHeight:{
      type: String,
      required: false,
      default: '200px',
    }
  },
  computed: {
    componentStyle() {
      return {aspectRatio: 1}
    },
    fontSize() {
      if (typeof this.size === 'number') {
        return this.size + 'px';
      }else if (typeof this.size === 'string'&&REGEXPS.SIZE_UNIT.test(this.size)) {
        return this.size;
      }else{
        return '1em';
      }
    },
    appendFontSize() {
      if (typeof this.appendFS === 'number') {
        return this.appendFS + 'px';
      }else if (typeof this.appendFS === 'string'&&REGEXPS.SIZE_UNIT.test(this.appendFS)) {
        return this.appendFS;
      }else{
        return '1em';
      }
    },
    width() {
      return this.size;
    },
    height() {
      return this.size;
    },
  },
  data() {
    return{
      showPreviewVisible: false,
    }
  },
  methods:{
    clickIcon() {
      this.$emit('click');
    },
  }
}
</script>

<style scoped>
.evan-icon{
 /* position: relative;*/
  background-color: transparent;
  vertical-align: middle;
  line-height: 1;
  display: inline-block;
  place-items: center;
  aspect-ratio: 1/1;
  width: max-content; /* 宽度由内容决定 */
}
.evan-icon *{
  border-radius: inherit;
}
.evan-icon__svg{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.icon{

  /*width: 1.5rem; height: 1.5em;*/
/*  width: 60px;height: 25px;*/
  /*vertical-align: -0.15em;*/
  fill: currentColor;
  overflow: hidden;
  vertical-align: middle;
}
.text{
  vertical-align: middle;
}
.tracking-in-expand {
  -webkit-animation: tracking-in-expand 0.7s cubic-bezier(0.215, 0.610, 0.355, 1.000) both;
  animation: tracking-in-expand 0.7s cubic-bezier(0.215, 0.610, 0.355, 1.000) both;
}
/* ----------------------------------------------
 * Generated by Animista on 2024-8-29 14:18:25
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation tracking-in-expand
 * ----------------------------------------
 */
@-webkit-keyframes tracking-in-expand {
  0% {
    letter-spacing: -0.5em;
    opacity: 0;
  }
  40% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
}
@keyframes tracking-in-expand {
  0% {
    letter-spacing: -0.5em;
    opacity: 0;
  }
  40% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
}




.scale-up-center {
  -webkit-animation: scale-up-center 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  animation: scale-up-center 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
}
/* ----------------------------------------------
 * Generated by Animista on 2024-8-29 14:1:7
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation scale-up-center
 * ----------------------------------------
 */
@-webkit-keyframes scale-up-center {
  0% {
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
@keyframes scale-up-center {
  0% {
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}


.translate-icon{
  transition: font-size .3s ease;
}

</style>
